export const sortByLabel = (object) => object.sort((a, b) => ((a.label > b.label) ? 1 : -1));
export const sortByValue = (object) => object.sort((a, b) => ((a.value > b.value) ? 1 : -1));
export const sortByVersion = (object) => object.sort((a, b) => ((a.version > b.version) ? 1 : -1));
